import {WarehouseModel} from "../warehouse/warehouse.model";

export class UserModel {

	userName: string;
	userType: string;
	hasAccess: boolean = false;
	roles: Array<string>;
	warehouse: WarehouseModel;
	country: string;
	language: string;

	constructor() {
		this.roles = new Array<string>();
		this.warehouse = new WarehouseModel();
	}
}
